<template>
  <div class="app">
    <HeaderView/>
    <div class="app-body">
      <Sidebar :navItems="nav"/>
      <main class="main">
        <breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <FooterView/>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import {
    HeaderView, Sidebar, FooterView, Breadcrumb,
} from '../components/admin';

export default {
    name: 'full',
    components:
  {
      HeaderView,
      Sidebar,
      FooterView,
      Breadcrumb,
  },
    data()
    {
        return {
            nav: [],
        };
    },
    created()
    {
        if (this.langInitialized)
        {
            this.initMenu();
        }
    },
    methods:
  {
      initMenu()
      {
          const me = this;

          const children = [];

          // console.log(JSON.stringify(me.globals.acl));

          if (me.globals.acl.AclPrivilages.updatePrivilage.insertAction)
          {
              children.push({
                  name: me.$i18n.t('ACL'),
                  url: '/system/acl',
                  icon: 'icon-lock',
              });
          }

          if (me.globals.acl.Translator.deleteAction)
          {
              children.push({
                  name: me.$i18n.t('TRANSLATOR'),
                  url: '/system/translator',
                  icon: 'icon-flag',
              });
          }

          if (me.globals.acl.TransLang.insertAction)
          {
              children.push({
                  name: me.$i18n.t('LANGUAGES'),
                  url: '/system/languages',
                  icon: 'icon-globe',
              });
          }

          if (me.globals.acl.SiteProps.insertAction)
          {
              children.push({
                  name: me.$i18n.t('SITEPROPS'),
                  url: '/system/siteprops',
                  icon: 'icon-wrench',
              });
          }

          if (me.globals.acl.EmailTemplates.insertAction)
          {
              children.push({
                  name: me.$i18n.t('EMAILTEMPLATES'),
                  url: '/system/emailtemplates',
                  icon: 'icon-envelope',
              });
          }

          if (me.globals.acl.UserCompanies.deleteAction)
          {
              children.push({
                  name: me.$i18n.t('USERCOMPANIES'),
                  url: '/system/usercompanies',
                  icon: 'icon-organization',
              });
          }

          if (me.globals.acl.Users.updateAction)
          {
              children.push({
                  name: me.$i18n.t('USERS'),
                  url: '/system/users',
                  icon: 'icon-user',
              });
          }

          if (me.globals.acl.AclPrivilages.insertRow.instantiate)
          {
              children.push({
                  name: me.$i18n.t('GENERATOR'),
                  url: '/system/generator',
                  icon: 'icon-rocket',
              });
          }

          // GENERATORINSERT

          this.nav = [{
              name: me.$i18n.t('DASHBOARD'),
              url: '/dashboard',
              icon: 'icon-home',
          },
          {
              name: me.$i18n.t('MODULES'),
              url: '/modules',
              icon: 'icon-rocket',
          },
          {
              name: me.$i18n.t('ACTIONLOG'),
              url: '/actionlog',
              icon: 'icon-pencil',
          },
          {
              name: me.$i18n.t('RULES'),
              url: '/rules',
              icon: 'icon-event',
          },
          {
              name: me.$i18n.t('IRDEVICES'),
              url: '/irdevices',
              icon: 'icon-eye',
          },
          {
              name: me.$i18n.t('SYSTEM'),
              icon: 'icon-settings',
              children,
          }];
      },
  },
    watch:
  {
      translation()
      {
          this.initMenu();
      },
      langInitialized()
      {
          this.initMenu();
      },
  },
    computed:
  {
      ...mapGetters([
          'langInitialized',
          'translation',
          'globals',
      ]),
      name()
      {
          return this.$route.name;
      },
      list()
      {
          return this.$route.matched;
      },
  },
};
</script>
